<template>
  <div>
    <validation-observer ref="examesComplementaresForm">
      <b-form @ubmit.prevent>
        <b-row class="mb-3">
          <b-col cols="12">
            <h5>ECG</h5>
            <b-row>
              <b-col md="6">
                <b-form-group label="Ritmo">
                  <b-form-input
                    v-model="parecer.examesComplementares.ecg.ritmo"
                    :disabled="disableForm"
                    placeholder="Informe o ritmo"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Traçado">
                  <b-form-input
                    v-model="parecer.examesComplementares.ecg.tracado"
                    :disabled="disableForm"
                    placeholder="Informe o traçado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Descrição das alterações">
                  <b-form-textarea
                    v-model="parecer.examesComplementares.ecg.alteradoDescricao"
                    :disabled="disableForm"
                    placeholder="Descreva as alterações encontradas"
                    rows="2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="12">
            <h5>Teste Ergométrico</h5>
            <b-row>
              <b-col md="6">
                <b-form-group label="Resultado">
                  <b-form-input
                    v-model="parecer.examesComplementares.testeErgometrico.resultado"
                    :disabled="disableForm"
                    placeholder="Informe o resultado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Descrição">
                  <b-form-textarea
                    v-model="parecer.examesComplementares.testeErgometrico.descricao"
                    :disabled="disableForm"
                    placeholder="Descreva os achados"
                    rows="2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="12">
            <h5>Ecocardiograma</h5>
            <b-row>
              <b-col md="6">
                <b-form-group label="Resultado">
                  <b-form-input
                    v-model="parecer.examesComplementares.ecodopplerCardiograma.resultado"
                    :disabled="disableForm"
                    placeholder="Informe o resultado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Descrição">
                  <b-form-textarea
                    v-model="parecer.examesComplementares.ecodopplerCardiograma.descricao"
                    :disabled="disableForm"
                    placeholder="Descreva os achados"
                    rows="2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="12">
            <h5>MAPA</h5>
            <b-row>
              <b-col md="6">
                <b-form-group label="Resultado">
                  <b-form-input
                    v-model="parecer.examesComplementares.mapa.resultado"
                    :disabled="disableForm"
                    placeholder="Informe o resultado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Descrição">
                  <b-form-textarea
                    v-model="parecer.examesComplementares.mapa.descricao"
                    :disabled="disableForm"
                    placeholder="Descreva os achados"
                    rows="2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="12">
            <h5>Holter de Arritmias</h5>
            <b-row>
              <b-col md="6">
                <b-form-group label="Resultado">
                  <b-form-input
                    v-model="parecer.examesComplementares.holterDeArritmias.resultado"
                    :disabled="disableForm"
                    placeholder="Informe o resultado"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Descrição">
                  <b-form-textarea
                    v-model="parecer.examesComplementares.holterDeArritmias.descricao"
                    :disabled="disableForm"
                    placeholder="Descreva os achados"
                    rows="2"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col cols="12">
            <h5>Outros Exames</h5>
            <b-form-group>
              <b-form-textarea
                v-model="parecer.examesComplementares.outros"
                :disabled="disableForm"
                placeholder="Informe outros exames complementares realizados"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Exames Complementares"
            label-save="Salvar Exames Complementares"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      examesComplementares: {},
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && !!newVal.examesComplementares) {
          this.setExamesComplementaresData(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Deseja realmente sair da atualização do Fator de Risco?",
          {
            title: "Confirmação",
            size: "sm",
            okVariant: "primary",
            okTitle: "Sim",
            cancelTitle: "Não",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setExamesComplementaresData(this.parecer);
      this.$refs.examesComplementaresForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    setExamesComplementaresData(data) {
      if (data && !!data.examesComplementares) {
        this.examesComplementares = {
          id: data.id,
          ...this.examesComplementares,
          ...data.examesComplementares,
        };
      }
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.examesComplementaresForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarExamesComplementares",
                this.examesComplementares
              )
              .then((response) => {
                this.examesComplementares = {
                  id: response.data.id,
                  ...this.examesComplementares,
                  ...response.data.examesComplementares,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Exames Complementares Editados com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
